export default __webpack_public_path__ + "static/Dr. Abdul Malek-0814d81bdc6890e0469cd807540596e3.jpeg";